import { useContext } from 'react';

import BookmarksContext from './bookmarks.context';

function useBookmarks() {
  const context = useContext(BookmarksContext);

  if (!context) {
    throw new Error('useBookmarks must be used within BookmarksContext');
  }

  return context;
}

export default useBookmarks;
